module.exports = __webpack_public_path__ + "img/img_fitness_app2_en.c0412149.png";